<lib-modal-layout [title]="data.title" [subtitle]="data.subTitle">
    <p class="text-center">Select the document type then browse for your file(s).</p>
    <form [formGroup]="fileTypeForm">
      <lib-form-dropdown
        label="File Type"
        formControlName="fileType"
        [options]="data.fileTypes()">
      </lib-form-dropdown>
      <lib-form-file-attachment
        formControlName="files"
        [acceptedFormats]="acceptedFormats()"
        placeholder="Drag and drop files here"
    ></lib-form-file-attachment>
    </form>
    <div class="upload-button">
      <lib-button [cssType]="'btn-primary'" [text]="'Upload'" [icon]="'rightarrow'"  [size]="'large'"  (click)="uploadFiles()"></lib-button>
    </div>
  
</lib-modal-layout>